import styled from "styled-components";

export const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.orange};
  border-radius: 20px;
  height: 40px;
  width: 100%;
  border: none;
  color: ${({ theme }) => theme.colors.white};
  font-size: 1rem;
  cursor: pointer;
  transition: filter 0.2s ease;

  &:disabled {
    filter: brightness(0.9);
    cursor: not-allowed;
  }

  div {
    width: 20px;
    height: 20px;
  }

  @media (min-width: 768px) {
    font-size: 1.125rem;

    div {
      width: 23px;
      height: 23px;
    }
  }
`;
